<template>
    <v-container grid-list-xl :class="$vuetify.breakpoint.smAndDown ? 'px-0' : ''" v-if="!prerenderMode">
        <template v-if="Object.values($basket.getBasketItems()).length > 0">
            <p class="display-1">{{ 'My Cart' | translation }}</p>
            <basket-items coupon :displayFreeShippingInfo="true" shipping-provider-selection flat-cards>
                <template #afterCoupon>
                    <page-content/>
                </template>

                <template v-slot:afterTotals>
                    <v-layout row wrap class="pt-3" justify-end>
                        <v-flex shrink v-if="$vuetify.breakpoint.mdAndUp" class="py-0">
                            <payment onBasket @success="onPaymentSuccess" card-text-class="pa-0"/>
                        </v-flex>

                        <v-flex shrink class="text-xs-right py-0">
                            <div>
                                <v-btn
                                    class="ma-0"
                                    color="primary"
                                    large
                                    :to="checkoutStepData"
                                    :disabled="shippingPrices && !Object.values(shippingPrices).length"
                                >
                                    {{ 'Proceed to checkout' | translation }}
                                </v-btn>
                            </div>
                        </v-flex>

                        <v-flex xs12 v-if="$vuetify.breakpoint.smAndDown" class="pa-0">
                            <payment onBasket @success="onPaymentSuccess" card-text-class="pb-0"/>
                        </v-flex>
                    </v-layout>
                </template>
            </basket-items>
        </template>
        <v-card v-else>
            <v-card-title>
                {{ 'Your cart is empty.' | translation }}
            </v-card-title>
            <v-card-actions>
                <v-btn to="/">{{ 'Continue shopping' | translation }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import {eventManager} from '@breakmedia/prime-vue-event-manager';
    import {mapState} from 'vuex';
    import ShippingSelector from './ShippingSelector';

    const moduleName = 'Basket';

    export default {
        name: moduleName,
        computed: {
            ...mapState(ShippingSelector.name, ['shippingPrices']),
            ...mapState('Customer', ['customerHasDSGVO']),
            ...mapState('PageContent', [
                'prerenderMode'
            ]),
            metaTitle() {
                return this.$language.translate('META_BASKET_TITLE');
            },
            metaDescription() {
                return this.$language.translate('META_BASKET_DESCRIPTION');
            },
            checkoutStepData() {
                return {
                    name: 'checkout',
                    params: {
                        stepName: this.customerHasDSGVO ? 'summary' : 'address',
                    }
                };
            },
        },
        metaInfo() {
            if (this.$router.currentRoute.name !== 'basket') {
                return {};
            }
            return {
                title: this.metaTitle,
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: this.metaDescription,
                    },
                ],
                __dangerouslyDisableSanitizersByTagID: {
                    description: ['content'],
                },
            };
        },
        methods: {
            onPaymentSuccess(orderData) {
                this.$router.push({
                    name: 'checkout',
                    params: {
                        stepName: 'success',
                    },
                    query: {
                        transaction_id: orderData.transaction_id,
                    },
                });
            },
        },
    };
</script>
